import { use } from "react";
import { InternetStatusContext } from "./InternetStatusContext";

export function useInternetStatus() {
  const internetStatusContext = use(InternetStatusContext);

  if (!internetStatusContext) {
    throw new Error("This Hook must be used under InternetStatusProvider!");
  }

  return internetStatusContext;
}
